module.exports = __webpack_public_path__ + "img/5-3.c2647563.png";